// BREACH RECORD
export const GET_BREACH_RECORDS = '/breach-record/query';
export const GET_BREACH_RECORD = '/breach-record/';
export const POST_BREACH_RECORD = '/breach-record/';
export const PUT_BREACH_RECORD = '/breach-record/';
export const DELETE_BREACH_RECORD = '/breach-record/';
